import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import { API_URL } from "./constants";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();


const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();
  setError("");

  try {
    const res = await fetch(`${API_URL}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      setError(data.error || "Login failed");
      return;
    }

    console.log("Login successful:", data);

    // Store token and user
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));

    // Check if user has business profile
    const businessRes = await fetch(`${API_URL}/api/business`, {
      headers: {
        "Authorization": `Bearer ${data.token}`
      }
    });

    const businessData = await businessRes.json();
    if (businessData.business) {
      // Has business, go to home
      localStorage.setItem("business", JSON.stringify(businessData.business));
      navigate("/dashboard");
    } else {
      // No business, force business setup
      navigate("/business-setup");
    }

  } catch (err) {
    console.error(err);
    setError("An unexpected error occurred");
  }
};

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>

        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            placeholder="Enter your email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            placeholder="Enter your password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="login-btn">Sign in</button>

        <p style={{ marginTop: "1rem" }}>
          Don’t have an account? <Link to="/signup">Sign up</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
